
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;

// Register User
export const registerUser = createAsyncThunk("auth/register", async (userData, { rejectWithValue }) => {
  try {
    console.log("userData", userData)
    const response = await axios.post(`${BASE_URL}/api/auth/register`, userData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// Login User
export const loginUser = createAsyncThunk("auth/login", async (userData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/auth/login`, userData);
    localStorage.setItem("token", response.data.accessToken); // Store JWT Token
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// Logged User
export const loggedUser = createAsyncThunk(
  "auth/user",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token"); // Fallback to ensure token retrieval
      if (!token) {
        return rejectWithValue({ error: "Token not found. Please log in again." });
      }

      const response = await axios.get(`${BASE_URL}/api/auth/user`, {
        headers: {
          Authorization: `Bearer ${token}`, // Securely send the token in the header
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { error: "Failed to fetch user data." }
      );
    }
  }
);


// Logout User
export const logoutUser = createAsyncThunk("auth/logout", async (_, { rejectWithValue }) => {
  try {
    await axios.post(`${BASE_URL}/api/auth/logout`); // API call to clear refreshToken
    localStorage.removeItem("token"); // Clear localStorage token
    return null;
  } catch (error) {
    return rejectWithValue(error.response?.data || { error: "Logout failed" });
  }
});

export const updateUserProfile = createAsyncThunk(
  "auth/updateUserProfile",
  async (userData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(`${BASE_URL}/api/auth/user`, userData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Failed to update user profile" });
    }
  }
);

export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async (passwordData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`${BASE_URL}/api/auth/change-password`, passwordData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Failed to update password" });
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/api/auth/forgot-password`, { email });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Failed to send password reset email" });
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ newPassword, token }, { rejectWithValue }) => {
    console.log("token pwd", token, newPassword)
    try {
      const response = await axios.post(`${BASE_URL}/api/auth/reset-password?token=${token}`, { newPassword },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },

      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Failed to reset password" });
    }
  }
);

export const verifyEmail = createAsyncThunk("auth/verifyEmail", async (token, { rejectWithValue }) => {
  console.log("token verify email", token);

  try {
    // const token = localStorage.getItem("token"); // Ensure token retrieval
    const response = await axios.get(`${BASE_URL}/api/auth/verify-email?token=${token}`);
    console.log("response verify email", response.data);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || { error: "Failed to verify email" });
  }
});

export const getAllUsers = createAsyncThunk("auth/getAllUsers", async (_, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${BASE_URL}/api/auth/users`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || { error: "Failed to get users" });
  }
});


export const sendOtp = createAsyncThunk("auth/sendOtp", async (number) => {
  const res = await axios.post(`${BASE_URL}/api/auth/send-otp`, { whatsappNumber: number });
  return res.data;
});

export const verifyOtp = createAsyncThunk("auth/verifyOtp", async ({ number, otp }) => {
  const res = await axios.post(`${BASE_URL}/api/auth/verify-otp`, { whatsappNumber: number, otp });
  return res.data;
});



// Auth Slice
const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: localStorage.getItem("token") || null,
    loading: false,
    error: null,
    success: false,
    message: null
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === "string"
          ? action.payload
          : action.payload?.message || "An error occurred";
      })
      .addCase(registerUser.rejected, (state, action) => {
        // state.error = typeof action.payload === "string"
        //   ? action.payload
        //   : action.payload?.error || "An error occurred";

        state.loading = false;
        state.error = action.payload?.error || "Registration failed";
      })
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === "string"
          ? action.payload
          : action.payload?.error || "An error occurred";

      })

      .addCase(loggedUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(loggedUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(loggedUser.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(logoutUser.fulfilled, (state, action) => {
        localStorage.removeItem("token"); // Ensure token is removed
        state.user = null;
        state.token = null;
        state.loading = false;
        state.success = false;
        state.message = null;
        state.error = null;
      })

      .addCase(updateUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user.data = action.payload.data;
        state.success = action.payload.success;
        state.message = action.payload.message;
        state.error = null
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "An unexpected error occurred";
      })
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.error = null
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "An unexpected error occurred";
      })

      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.error = null
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "An unexpected error occurred";
      })

      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "An error occurred";
        state.message = null;
      })

      .addCase(verifyEmail.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;  // ✅ Clear error on success
        state.message = action.payload.message;
      })
      .addCase(verifyEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "Failed to verify email";
        state.message = null;
      })

      // .addCase(resendVerificationEmail.pending, (state) => {
      //   state.loading = true;
      // })
      // .addCase(resendVerificationEmail.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.error = null;  // ✅ Clear error on success
      //   state.message = action.payload.message;
      // })
      // .addCase(resendVerificationEmail.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload?.error || "Failed to resend verification email";
      //   state.message = null;
      // })

      .addCase(getAllUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.users;
        state.error = null;  // ✅ Clear error on success
        state.message = action.payload.message;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "Failed to fetch users";
        state.message = null;
      })


      .addCase(sendOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.error = null

      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.error = null
      })

      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.message = action.payload.message;
      });





  }
});
export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
